import { render, staticRenderFns } from "./logoutMenu.vue?vue&type=template&id=67d67351&scoped=true&"
import script from "./logoutMenu.vue?vue&type=script&lang=js&"
export * from "./logoutMenu.vue?vue&type=script&lang=js&"
import style0 from "./logoutMenu.vue?vue&type=style&index=0&id=67d67351&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d67351",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oeze/Documents/grupa/grupa-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67d67351')) {
      api.createRecord('67d67351', component.options)
    } else {
      api.reload('67d67351', component.options)
    }
    module.hot.accept("./logoutMenu.vue?vue&type=template&id=67d67351&scoped=true&", function () {
      api.rerender('67d67351', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Popups/logoutMenu.vue"
export default component.exports